import xlsx from "json-as-xlsx";
import { useEffect, useState } from "react";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { useAppDispatch } from "../../app/store";
import TableList from "../../components/TableList/TableList";
import Button from "../../components/reusable/Button/Button";
import DateTimePicker from "../../components/reusable/DateTimePicker/DateTimePicker";
import Input from "../../components/reusable/Input/Input";
import Pagination from "../../components/reusable/Pagination/Pagination";
import Selector from "../../components/reusable/Selector/Selector";
import { setLoadingPageScreen } from "../../features/Dashboard/Slices/dashboardSlice";
import useAuth from "../../hooks/useAuth";
import { toastError } from "../../utils/toast";
import "./EventosInscripcion.css";
import moment from "moment";

const nivelEventosOptions = [
  { text: "INFO", value: "INFO" },
  { text: "WARNING", value: "WARNING" },
  { text: "ERROR", value: "ERROR" },
];

function EventosInscripcion() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEvents, setTotalEventos] = useState(0);
  const [tipoEventosOptions, setTipoEventosOptions] = useState<any[]>([]);
  const [eventos, setEventos] = useState<any[]>([]);
  const [tipoEvento, setTipoEvento] = useState("");
  const [idTx, setIdTx] = useState("");
  const [idCupo, setIdCupo] = useState<number | null>(null);
  const [idAlumnoPrograma, setIdAlumnoPrograma] = useState<number | null>(null);
  const [fechaDesde, setFechaDesde] = useState(() => {
    return moment().subtract(2, 'hours').format('YYYY-MM-DDTHH:mm');
  });
  const [fechaHasta, setFechaHasta] = useState(() => {
    return moment().hour(23).minute(59).format('YYYY-MM-DDTHH:mm');
  });
  const [displayPageSize, setDisplayPageSize] = useState("100");
  const [actualPageSize, setActualPageSize] = useState("100");
  const { hasPermission } = useAuth();
  const dispatch = useAppDispatch();
  const [nivelEvento, setNivelEvento] = useState("");

  const limpiarFiltros = () => {
    setTipoEvento("");
    setNivelEvento("");
    setIdTx("");
    setIdCupo(null);
    setIdAlumnoPrograma(null);
    setFechaDesde("");
    setFechaHasta("");
  };

  console.log(fechaDesde);

  const setLoading = (newState: boolean) => {
    dispatch(setLoadingPageScreen(newState));
  };

  const exportEventos = async () => {
    try {
      // Enviar las fechas en el formato YYYY-MM-DDTHH:mm
      const data = await dashboardAPI.exportEventos(fechaDesde, fechaHasta);
      let settings = {
        fileName: "Eventos", // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      console.log("data:", data);
      xlsx(data, settings);
    } catch (error: any) {
      console.log(`ERROR: ${error.message}`);
      toastError();
    }
  };

  const getEventos = async (newPage?: number) => {
    setLoading(true);
    try {
      const pageSizeChanged = actualPageSize !== displayPageSize;
      setActualPageSize(displayPageSize);
      const pageToUse = pageSizeChanged ? 1 : (newPage ? newPage : currentPage);
      setCurrentPage(pageToUse);
      const offset = (pageToUse - 1) * Number(displayPageSize);
      const newData = await dashboardAPI.getEventosInscripcionPaginados(Number(displayPageSize), offset, tipoEvento, Number(idTx), Number(idCupo), Number(idAlumnoPrograma), fechaDesde, fechaHasta, nivelEvento);
      setEventos(newData.eventos);
      setTotalEventos(newData.totalCount);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  const getTiposEvento = async () => {
    const tiposEvento = await dashboardAPI.getTiposEventoSoporte();
    const tiposOptions = tiposEvento.map((tipo) => ({ text: tipo, value: tipo }));
    setTipoEventosOptions(tiposOptions);
  }

  useEffect(() => {
    getEventos();
    getTiposEvento();
  }, []);

  const defaultVisibleColumns = {
    tipo: true,
    nivel: true,
    usuarioAccion: true,
    informacion: true,
    carrera: true,
    idPersona: true,
    mail: true,
    apellidoNombre: true,
    idCupo: true,
    idCurso: true
  };

  return (
    <div className="flex flex-1">
      <div className="eventosPage">
        <div className="filtersContainer">
          <div className="flex flex-row items-start gap-4 mb-4">
            <div className="flex flex-row items-end gap-2">
              <div className="flex flex-col w-40">
                <strong>Tipo de evento</strong>
                <Selector
                  placeholder="Tipo de evento"
                  options={tipoEventosOptions}
                  className="w-full"
                  onSelect={(value) => setTipoEvento(value)}
                  value={tipoEvento}
                />
              </div>
              <div className="flex flex-col w-40">
                <strong>Nivel de evento</strong>
                <Selector
                  placeholder="Nivel de evento"
                  options={nivelEventosOptions}
                  className="w-full"
                  onSelect={(value) => setNivelEvento(value)}
                  value={nivelEvento}
                />
              </div>
              <div className="flex flex-col w-32">
                <strong>idTx</strong>
                <Input
                  placeholder="idTx"
                  onChange={(idTx) => setIdTx(idTx)}
                  type="number"
                  value={idTx}
                />
              </div>
              <div className="flex flex-col w-32">
                <strong>idCupo</strong>
                <Input
                  placeholder="idCupo"
                  value={String(idCupo)}
                  onChange={(idCupo) => setIdCupo(Number(idCupo))}
                  type="number"
                />
              </div>
              <div className="flex flex-col w-40">
                <strong>idAlumnoPrograma</strong>
                <Input
                  placeholder="idAlumnoPrograma"
                  value={String(idAlumnoPrograma)}
                  onChange={(idAlumnoPrograma) =>
                    setIdAlumnoPrograma(Number(idAlumnoPrograma))
                  }
                  type="number"
                />
              </div>
              <div className="flex flex-row items-end gap-2 ml-auto">
                <Button
                  label="Actualizar lista"
                  iconName="search"
                  onClick={() => getEventos()}
                  disabled={!hasPermission("eventos", "actualizar_lista")}
                />
                <Button
                  label="Exportar a XLS"
                  iconName="download"
                  onClick={() => exportEventos()}
                  theme="green"
                  disabled={!hasPermission("eventos", "exportar_a_xls")}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row items-end gap-4 w-1/2">
            <DateTimePicker
              label="Fecha desde"
              value={fechaDesde}
              onChange={setFechaDesde}
              className="w-52"
            />
            <DateTimePicker
              label="Fecha hasta"
              value={fechaHasta}
              onChange={setFechaHasta}
              className="w-52"
              defaultTime="23:59"
            />
            <div className="flex flex-col w-32">
              <strong>Registros por página</strong>
              <Input
                placeholder="Cantidad"
                value={displayPageSize}
                onChange={(value) => {
                  const numValue = parseInt(value);
                  if (!isNaN(numValue) && numValue > 0) {
                    setDisplayPageSize(value);
                  }
                }}
                type="number"
              />
            </div>
            <Button
              label="Limpiar filtros"
              theme="default"
              iconName="eraser"
              onClick={limpiarFiltros}
            />
          </div>
        </div>
        <div className="flex flex-col px-10 py-2 flex-1">
          {eventos.length ? <>
            <div className="tableListCont">
              <TableList list={eventos} defaultVisibleColumns={defaultVisibleColumns} enableSearchbar columnWidth={180} page={"eventosInscripcion"} />
            </div>
            <Pagination
              onPageChange={getEventos}
              currentPage={currentPage}
              totalCount={totalEvents}
              pageSize={Number(actualPageSize)}
            />
          </>
            : <p>No hay eventos</p>}

        </div>
      </div>
    </div>
  );
}

export default EventosInscripcion;
